import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ToastService } from '../../services/notification/toast.service';
import { WebService}  from '../../services/web/web.service';
import {SpinnerService} from '../../services/spinner/spinner.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PlanService} from "../plans/plan.service";
import {environment} from '../../../environments/environment';
import {SecurityService} from "../../services/security.service";
import { shouldShowPaymentButton } from '../../shared/utils/onboarding-payment-status';

@Component({
    selector: 'app-update-portal-template',
    templateUrl: './update-portal-template.component.html',
    styleUrls: ['./update-portal-template.component.scss'],
    standalone: false
})
export class UpdatePortalTemplatesComponent implements OnInit {
    checkboxBasicValue = false;
    checkboxPracticalValue = false;
    checkboxContempoValue = false;
    exist = false;
    onboardingConfigID: any;
    checked: any;
    fromUpdate: Boolean = false;
    showPaymentButton: Boolean = false;

    constructor(private securityService: SecurityService,
                private planService: PlanService,
                private activateRoute: ActivatedRoute,
                private router: Router,
                private location: Location,
                private toast: ToastService,
                private spinner: SpinnerService,
                private webService: WebService) {
    }

    ngOnInit(): void {

        this.activateRoute.queryParams.subscribe(queryParams => {

            if (queryParams['update']) {
                this.fromUpdate = true;
            }
            this.activateRoute.params.subscribe(params => {
                this.onboardingConfigID = params['id'];
                this.getConfigByID();
            }, err => {
                this.toast.showError(err);
            });

        }, err => {
            this.toast.showError(err);
        })


    }

    getConfigByID() {
        this.spinner.open(); // ✅ Mostramos el loader desde el principio


        let partner = -1;
        if(this.securityService.getTokenPartner() != null || this.securityService.getTokenPartner() != undefined){
            partner = this.securityService.getTokenPartner()
        }

        this.webService.get(`${this.webService.HOST}/onboardingConfig/${this.onboardingConfigID}?partner=${partner}`).subscribe(config => {
            this.spinner.close(); // ✅ Cerramos el loader cuando llega la data

            const templateValue = config.result.portal_identifier;
            console.log("🧩 Template recibido (portal_identifier):", templateValue);
            this.selectTemplate(templateValue);

            this.showPaymentButton = shouldShowPaymentButton(config);

            this.planService.plans.emit(config.result.plans);

        }, err => {
            this.spinner.close(); // ✅ También lo cerramos si hay error
            this.toast.showError(err);
            console.log("AQUI");
        });
    }


    selectTemplate(templateNumber: number) {
        this.checked = templateNumber;

        // Reiniciar todos
        this.checkboxBasicValue = false;
        this.checkboxPracticalValue = false;
        this.checkboxContempoValue = false;

        if (templateNumber === 1) {
            this.checkboxBasicValue = true;
        } else if (templateNumber === 2) {
            this.checkboxPracticalValue = true;
        } else if (templateNumber === 3) {
            this.checkboxContempoValue = true;
        }
    }

    saveTemplate() {
        if (this.checked == undefined) {
            this.toast.showError("Debes seleccionar un template para continuar");
        }

        this.spinner.open();
        let json = {
            partner: this.securityService.getTokenPartner(),
            config: this.onboardingConfigID,
            template: this.checked
        };
        this.webService.put(json, this.webService.HOST + "/onboarding/step2").subscribe(response => {
                this.spinner.close();

                this.toast.showSuccess("Template actualizado correctamente, en unos minutos podra visualizarlo correctamente en su portal");

                if (!this.fromUpdate) {
                    this.goToFeatures();
                }

            }, err => {
                this.spinner.close();
                this.toast.showError(err)
            }
        )
    }


    handleCheckboxChange(checkboxType: string) {
        this.checkboxBasicValue = false;
        this.checkboxPracticalValue = false;
        this.checkboxContempoValue = false;

        if (checkboxType === 'basic') this.checkboxBasicValue = true;
        if (checkboxType === 'practical') this.checkboxPracticalValue = true;
        if (checkboxType === 'contempo') this.checkboxContempoValue = true;
    }

    goToFeatures() {

        this.router.navigate(["/edit/portal/" + this.onboardingConfigID + '/features']);
    }

    goToPortals() {
        this.router.navigate(["/my-portals"], {relativeTo: this.activateRoute, queryParamsHandling: "preserve"});
    }


}
